
  import { Component, OnInit, Output, EventEmitter, Input, ViewChild, TemplateRef } from '@angular/core';
  import { HttpClient } from '@angular/common/http';
  import { NbDialogService } from '@nebular/theme';
  import { CookieService } from 'ngx-cookie-service';
  
  import * as _ from 'lodash';

@Component({
  selector: 'app-select-attachmoudle',
  templateUrl: './select-attach-moudle.component.html',
  styleUrls: ['./select-attach-moudle.component.scss']
})
export class SelectAttachMoudleComponent implements OnInit {


  USR_AccountInfo_ID: string;
  ORG_Company_ID: number;
  ORG_Store_ID: number
  @Output() emitClose = new EventEmitter();
  @Output() emitList = new EventEmitter();
  @Input() orgData: Array<any>;  //已選資料_來源
  @Input() info: {
    IsLoding:boolean
    ORG_Store_ID: number,
  };

  //-----------------------談窗----------------------------

  modalRef = null;  //談窗鉤子
  PdModalRef = null;  //談窗鉤子

  @ViewChild('Modal') Modal: TemplateRef<any>
  @ViewChild('PdModal') PdModal: TemplateRef<any>

  //--------------------------------------------------------
  //資料清單
  mainDataList: Array<ProductGroup>; //選單資料
  showList: Array<any>;     //群組顯示資料 
  showListPd: Array<any>;   //商品顯示資料 
  selectList :  Array<Product> = [];  
  query = {  //查詢選項
    searchKey: ""
  }
  status: { //當前狀態
    isSelectAll: boolean //是否已全選
    showType: number // 顯示有選過的
  }

 //查詢的門市
 storeSelectList: selectData[];
 selectORG_Store_ID: number;


  constructor(
    private dialogService: NbDialogService,
    private http: HttpClient,
    private cookieService: CookieService,
  ) {
     this.USR_AccountInfo_ID = this.cookieService.get('USR_AccountInfo_ID') ? 
      "USR_AccountInfo_ID_"+this.cookieService.get('USR_AccountInfo_ID') :
        this.cookieService.get('USR_POSEmployeeInfo_ID') ?  
          "USR_POSEmployeeInfo_ID"+this.cookieService.get('USR_POSEmployeeInfo_ID') : null;
  
    let cookie_sid = this.cookieService.get('ORG_Store_ID')
    this.ORG_Store_ID = (cookie_sid && cookie_sid != '') ? parseInt(cookie_sid) : null
    this.ORG_Company_ID = parseInt(this.cookieService.get('ORG_Company_ID'));
  }



  ngOnInit(): void {

    
  }

  ngAfterViewInit() {
    this.onOpen(this.info, this.orgData)
  }


  
  //取得門市清單 API
  getStoreList(fun) {//取得門市清單 USP_YOPOSWebGetStoreList

    



    this.http.post<any>('api/ORGStore/StoreList', {
  
      ORG_Company_ID: this.ORG_Company_ID,
      ORG_Store_ID: this.ORG_Store_ID,
    }).subscribe({
      next: data => {
  
        this.storeSelectList = [];
  
  
        //門市共用下拉選單
        let Item :any= {};
        Item.value = 0;
        Item.content = '總部';
        this.storeSelectList.push(Item);
    
        if(this.ORG_Store_ID ){
    
             //門市共用下拉選單
             let Item :any= {};
             Item.value = this.ORG_Store_ID;
             Item.content = data.LIST.find(x=>x.ORG_Store_ID == this.ORG_Store_ID ).StoreName;
             this.storeSelectList.push(Item);
    
        }else{
  
          data.LIST.forEach(element => {
            //門市共用下拉選單
            var selectItem = new selectData();
            selectItem.value = element.ORG_Store_ID;
            selectItem.content = element.StoreName;
            this.storeSelectList.push(selectItem);
          });
    
    
        }
        
        // 預設點第一個
        if (this.storeSelectList.length > 0) {
          this.selectORG_Store_ID = this.storeSelectList[0].value
        }

        if(fun)
          fun()
      },
      error: error => {
        console.error('There was an error!', error);
      }
    });
  
    }


  onOpen(info, dataList) {

    

    if (info)
      this.info = info

    this.getStoreList(()=>{

      //api抓資料
      this.getPdGroupList((data) => {
        this.showData(data, dataList)

      })
    })


    //開啟談窗
    this.modalRef = this.dialogService.open(this.Modal, {})
    this.modalRef.onClose.subscribe(result => {
      this.emitClose.emit(true);
    });
  }


  // 組資料
  showData(data, orgData) {
    
    let ProductList = [];
    data.forEach(k => {    
      let g = new ProductGroup()
      Object.assign(g,k)   
      if (!orgData) {
        g.PDList = null 
        g.IsOK_Group = false
      }
      ProductList.push(g)
    });

    //判斷是否勾選，並撈取有勾選得群組商品資料
    if (orgData) {  //orgData 格式 {GroupNo:y.GroupNo,No:y.No}
      let list = _.groupBy(orgData, 'GroupNo');
      let key = _.keys(list)
      key.forEach(x=>{
        let group = _.find(ProductList, a => a.GroupNo == x)
        if (group) {
          group.IsOK_Group = true
          if(!group.PDList){
            this.getPdList(group,()=>{  
              _.forEach(group.PDList, p => {
                if(_.findIndex(orgData, op => p.No == op.No)>-1){
                  p.IsOK_Group = true
                  p.IsOK_Product = true
                }               
              });
              
              group.IsOK_Product_Count()
            })   
          }       
        
        }
      })
      
    }
 
    this.mainDataList = ProductList
     //合併到原始資料
    this.orgData = _.cloneDeep(this.mainDataList)
  }

  

  //---------------------------------------------------

  //查詢
  onQuery() {

    //組合舊資料
    let useData = this.tranfOrgData(this.selectList)
   


    this.getPdGroupList((data) => {
      this.showData(data, useData)
    })

  }

  //商品群組 選擇
  onSelectG(groupData) {
    if (!groupData.PDList ) {
      this.getPdList(groupData,()=>{  

        _.forEach(groupData.PDList, p => {
          p.IsOK_Group = groupData.IsOK_Group
          p.IsOK_Product = groupData.IsOK_Group
          this.insertData(p,groupData.IsOK_Group)
        });
        groupData.IsOK_Product_Count()

        
        
      })
    }else{
      _.forEach(groupData.PDList, p => {
        p.IsOK_Group = groupData.IsOK_Group
        p.IsOK_Product = groupData.IsOK_Group
        this.insertData(p,groupData.IsOK_Group)
      });
      groupData.IsOK_Product_Count()
    }

   
  }

  
  

  //處存商品群組
  onSavePdG() {

    let useData= []
    if(this.mainDataList){
      useData = this.tranfOrgData(this.selectList)    
    }

    
   
    this.emitList.emit(useData)
    this.modalRef.close()
  }


  
  

  //---------------------------------------------------


  //商品 打開彈窗
  onOpenPd(groupData) {
    if (!groupData.PDList) {
      this.getPdList(groupData,()=>{
        this.showListPd = _.cloneDeep(groupData.PDList)  
        this.PdModalRef = this.dialogService.open(this.PdModal, {})
      })
    }else{

      this.showListPd = _.cloneDeep(groupData.PDList)  
      this.PdModalRef = this.dialogService.open(this.PdModal, {})
      
    }
   
  }

  //商品 處存
  onSavePd() {
    

    let GID = this.showListPd[0].PRDMenuAttachItemModelNo
    let group = _.find(this.mainDataList, a => a.PRDMenuAttachItemModelNo == GID)
    
    _.assign(group.PDList, this.showListPd)
    group.IsOK_Group = _.findIndex(group.PDList, 'IsOK_Product') > -1
    group.IsOK_Product_Count()
    this.PdModalRef.close()
  }

  //---------------------------------------------------

  //將畫面型資料轉成結果資料
  tranfOrgData(dataList){
    let useData = []
    dataList.forEach(x=>{
      // if(x.PDList){
        // x.PDList.forEach(y=>{
          // if(y.IsOK_Product)
          if(x.IsOK_Product)
            // useData.push(y)
            useData.push(x)
        })
      // }   
    // })

    return useData
  }

  //將選擇的資料和併入selectList
  insertData(data,isAdd){
    if(isAdd){
      this.selectList.push(data)
    }else{
      this.selectList = this.selectList.filter(x=>x.No!=data.No)
    }
    
  }


  //取得可用商品資料
  getPdGroupList(fun) {
    let par = {
      ORG_Company_ID: this.ORG_Company_ID,
      CreateStore : this.selectORG_Store_ID,
      IsDelete: false,
      Keyword: this.query.searchKey,
    }

    this.info.IsLoding= true
    this.http.post<any>('api/AttachItemSetting/GetAttachItemGroup', par).subscribe({
      next: data => {
        this.info.IsLoding= false
        data.LIST.forEach(x=>x.GroupNo = x.PRDMenuAttachItemModelNo)

        if (fun)
          fun(data.LIST)

     

      },
      error: error => {
        console.error('There was an error!', error);
        this.info.IsLoding= false

      }
    });
  }

  //取得內容清單
  getPdList(groupData,fun) {

    this.info.IsLoding= true
      this.http.get<any>('api/AttachItemSetting/GetAttachItemList?PRDMenuAttachItemModelNo=' +
      groupData.PRDMenuAttachItemModelNo +
      `${this.ORG_Store_ID !=null ? "&ORG_Store_ID=" + this.ORG_Store_ID : ''}`+
        '&IsDelete=false&Page=1&PerPage=9999' 
      ).subscribe({
        next: data => {
          groupData.PDList = data.LIST
          groupData.PDList.forEach(x=>{
            x.GroupNo = groupData.GroupNo
            x.No = x.PRDMenuAttachItemGroupNo
          })

          if (fun)        
            fun(data.LIST)

        this.info.IsLoding= false

         
        },
        error: error => {
          console.error('There was an error!', error);
        this.info.IsLoding= false

        }
      });




  }
  


}

class ProductGroup {
  GroupNo: string;
  GroupName: string;
  IsOK_Group: boolean;
  PDList: Product[];
  CountStr: string;
  IsOK_Product_Count() {
    // console.log('go')
    let use = _.filter(this.PDList, 'IsOK_Product').length
    this.CountStr = (this.PDList && use == this.PDList.length) ? '已全選' : `已選${use}項`
  }

}

class Product {
  No: string;  
  IsOK_Group: boolean;
  IsOK_Product: boolean;
  //-----------------其他

}


class selectData {
  value: number;//
  content: string;//
  info:string
}







